module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/error.896e6809.svg";